<template>
   <b-container>
        <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
			<h3>Assign job to </h3><hr>
        </b-col>
		</b-row>
		<b-row>
			<hr>
            <b-col>
               
                    <!--<form action="viewTickets" id="viewTicket" method="get">-->
                        <b>Assign job #{{idTicket}} to</b>	
                        <select class="form-control" id="id_employee" name="Reason" style="overflow:scroll;" v-model="assignToId">
                            <option :value="user.idEmployee" v-for="user in users"  v-bind:key="user.idEmployee" >{{user.employee}}<br></option>
                        </select>
                        <b>New Comment</b><textarea   name="comment" id="id_Comment" rows="4" class="form-control" v-model="comment"></textarea ><br>
					
                        <button  name="Resolve" class="btn btn-primary"  id="submitbtn" style="width:100%;" @click="resolveJob">Assign Job</button>
                        <br><br>
                        <button  name="Cancel" id="cancelbtn" class="btn btn-primary" style="width:100%;" @click="$router.go(-1)">Cancel</button>
                        
                      <!--</form>-->
			</b-col>
		</b-row>
	</b-container>	
</template>		

<script type="text/javascript">
    import axios from 'axios';
    import moment from 'moment';

    export default {
     name: 'viewMyJobs',
      data: () => ({
        employee : "",
        idTicket : null,
        resolveDate : null,
        assignToId : 7,
        comment : "",
        users : []
       
        }),
      created : function () {
          this.idTicket = this.$route.params.idTicket;
          var mainObject = this;
          mainObject.resolveDate = moment().toISOString();
          axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
            params: {
               
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                console.log("getting users");
            console.log(response.data);
            mainObject.users = response.data.users;
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
            console.log("Made request to  getReasonTicket ");
           
        }); 
          //console.log("Set date to "+mainObject.resolveDate);
      },
      methods : {
          resolveJob : function () {
			
			let mainObject = this;
			
			if ( mainObject.comment.length < 1 )
			{
					let timerInterval
                    mainObject.$swal({
                    //title: 'Auto close alert!',
                    html: 'Please add a comment.',
                    timer: 2000,
                    onBeforeOpen: () => {
                        mainObject.$swal.showLoading()
                        timerInterval = setInterval(() => {
                        mainObject.$swal.getContent().querySelector('strong')
                           
                        }, 100)
                    },
                    onClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    if (
                        // Read more about handling dismissals
                        result.dismiss === mainObject.$swal.DismissReason.timer
                    ) {
                        //console.log('I was closed by the timer');
                        //mainObject.$router.go(-1);
                    }
                    }) 				
			}
			else
			{
               
                let idemployee =  localStorage.getItem('idemployee'); // this is the logged in user
                axios.get(localStorage.getItem('ticketCopURL') +'/assignJobTo', {
                    params: {
                        
                        idTicket : mainObject.idTicket,
                        comment : mainObject.comment,
                        assignToId : mainObject.assignToId,
                        test : "testValue",
                        employee : localStorage.getItem('employee'),
                        idEmployee : idemployee
                    
                    },
                     headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                        console.log("response log ticket");
                        console.log(response.data)
                        if ( response.data.status == "Success" )
                        {
                            let timerInterval
                            mainObject.$swal({
                            //title: 'Auto close alert!',
                            html: 'Ticket #'+mainObject.idTicket+' was succesfully re-assigned.',
                            timer: 2000,
                            onBeforeOpen: () => {
                                mainObject.$swal.showLoading()
                                timerInterval = setInterval(() => {
                                mainObject.$swal.getContent().querySelector('strong')
                                    
                                }, 100)
                            },
                            onClose: () => {
                                clearInterval(timerInterval)
                            }
                            }).then((result) => {
                            if (
                                // Read more about handling dismissals
                                result.dismiss === mainObject.$swal.DismissReason.timer
                            ) {
                                //console.log('I was closed by the timer');
                                mainObject.$router.go(-1);
                            }
                            })  
                        }
                        else
                        {
                            let timerInterval
                            mainObject.$swal({
                            //title: 'Auto close alert!',
                            html: 'Error could not assign Job.',
                            timer: 1000,
                            onBeforeOpen: () => {
                                mainObject.$swal.showLoading()
                                timerInterval = setInterval(() => {
                                mainObject.$swal.getContent().querySelector('strong')
                                    
                                }, 100)
                            },
                            onClose: () => {
                                clearInterval(timerInterval)
                            }
                            }).then((result) => {
                            if (
                                // Read more about handling dismissals
                                result.dismiss === mainObject.$swal.DismissReason.timer
                            ) {
                                //console.log('I was closed by the timer');
                                //mainObject.$router.go(-1);
                            }
                            }) 

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        let timerInterval
                        mainObject.$swal({
                        //title: 'Auto close alert!',
                        html: 'Error could not assign Job',
                        timer: 1000,
                        onBeforeOpen: () => {
                            mainObject.$swal.showLoading()
                            timerInterval = setInterval(() => {
                            mainObject.$swal.getContent().querySelector('strong')
                                
                            }, 100)
                        },
                        onClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        if (
                            // Read more about handling dismissals
                            result.dismiss === mainObject.$swal.DismissReason.timer
                        ) {
                            //console.log('I was closed by the timer');
                            //mainObject.$router.go(-1);
                        }
                        }) 
                    })
                    .then(function () {
                    // always executed
                    console.log("Made request to assign Job Done");
                    
                }); // end of axios call
			}
		
		//});
          }
      }
    }
</script>



